module.exports = __webpack_public_path__ + "img/1_autumn.a15fb724.png";